
import { Component, Vue } from "vue-property-decorator";
import { searchCustomer } from "@/api/customer";
import { COMPANY_OPTIONS } from "@/constant";
import {
  getHqPackingListsPackages,
  searchCustomerHqPackingList,
  queryOriginalPackingListInfoByCLPackingList
} from "@/api/hq-packing-list";
import {CustomsPackingProblemType, ProductInfo} from "@/model/HqPackingListModels";
import { Message } from "element-ui";
import {
  addRemark,
  addShippingOrder,
  cancelHenganLoadingPlan,
  checkPacking,
  createOrUpdateHenganLoadingPlan,
  detailQueryQtyStepInfoByPackingList,
  detailQueryQtyStepInfoByPi,
  downloadPreviewDetail,
  getContainerTypeConfigurationInfoForWarehouse,
  getHenganLoadingPlanProductAssigned,
  getHenganLoadingPlans,
  releaseContainerType,
  removeHenganLoadingPlanPackingInfos,
  updateHenganLoadingPlanPackingInfos,
  updateShippingOrder
} from "@/api/hengan-loading-plan";
import Pagination from "@/components/Pagination/index.vue";
import { IUserModel } from "@/api/types";
import { getUsersByJobPosition } from "@/api/users";
import {
  getShippingOrderContainerTypeReleasedInfo,
  getShippingOrders,
} from "@/api/shipping-order";
import { ShippingOrderModel } from "@/model/shipping-order";
import ContainerTypeConfiguration from "@/views/system-management/information/ContainerTypeConfiguration.vue";
import ContainerTypeReleasedInfo, {
  ContainerTypeReleasedInfoModel
} from "@/views/components/ContainerTypeReleasedInfo.vue";
import {
  deleteContainerTypeRelations,
  updateContainerTypeLoadingType,
} from "@/api/container-type";
import { exportJson2Excel } from "@/utils/excel";
import { formatJson } from "@/utils";
import { cloneDeep, values } from "lodash";
import ConfigContainerTypeComponent, {
  ContainerTypeConfigurationInfo,
} from "@/views/components/ConfigContainerTypeComponent.vue";
import {
  CustomsPackingModel,
  HqPackingListModel, HqPackingListState,
  LoadingInfo,
  PackingVolume,
  PackingWeight,
  SecondaryPackingModel
} from "@/model/HenganLoadingPlanModels";
import {
  deleteLoadingInfosForSeller,
  saveLoadingInfosFowSeller,
} from "@/api/loading-info";
import {
  ConfigContainerTypeRequest,
  CreateLoadingInfoRequest,
} from "@/views/warehouse-management/HenganLoadingPlanManagementForWarehouse.vue";
import Template from "@/views/system-management/template/index.vue";
import AsyncTooltip from "@/components/AsyncTooltip/index.vue";
import CustomsDeclarationPreviewDialog, {
  CustomsDeclarationPreviewItem,
} from "@/views/sales-management/components/CustomsDeclarationPreviewDialog.vue";
import PackingListProductListDialog, {
  PackingListProductItem,
} from "@/views/components/PackingListProductListDialog.vue";
import PiProductListDialog, {
  PiProductItem,
} from "@/views/components/PiProductListDialog.vue";
import {previewCustomsDeclaration} from "@/api/booking-order";
import {formatPrice, hasMoreThanTwoDecimals} from "@/utils/number";

@Component({
  name: "HenganLoadingPlan",
  components: {
    AsyncTooltip,
    Template,
    ContainerTypeReleasedInfo,
    ContainerTypeConfiguration,
    ConfigContainerTypeComponent,
    Pagination,
    CustomsDeclarationPreviewDialog,
    PackingListProductListDialog,
    PiProductListDialog,
  },
})
export default class extends Vue {
  private configContainerTypeDialogVisibleTitle = '出库单';
  private createHenganLoadingPlanDialogVisible = false;
  private updateHenganLoadingPlanDialogVisible = false;
  private checkedAll = false;
  private isLoadingCustomers = false;
  private customers: Customer[] = [];
  private selectedHqPackingListIds: string[] = [];
  private companyOptions = COMPANY_OPTIONS;
  private cascaderProps = {
    multiple: true,
    value: "id",
    label: "code",
    emitPath: false,
    disabled: "disabled"
  };
  private cascaderOptions: CascaderOptionItem[] = [];
  private customsPackingSet: CustomsPackingModel[] = [];
  private customsPackingTableData: CustomsPackingTableRowData[] = [];
  private henganLoadingPlans:any = [];
  private createHenganLoadingPlanRequest: CreateHenganLoadingPlanRequest = this.getCreateHenganLoadingPlanRequest();
  private logisticsSpecialist: IUserModel[] = [];
  private shippingOrders: ShippingOrderModel[] = [];
  private addShippingOrderDialogVisible = false;
  private releaseContainerTypeDialogVisible = false;
  private currentRow: HenganLoadingPlanTableRowData =
    new HenganLoadingPlanTableRowData();
  private isLoadingShippingOrders = false;
  private isLoadingContainerTypeReleasedInfo = false;
  private currentSelectedShippingOrderId: string = null;
  private containerTypeReleasedInfo: ContainerTypeReleasedInfoModel =
      new ContainerTypeReleasedInfoModel();
  private data: PackingInfo[] = [];
  private packingInfoRequest: HenganLoadingPlanPackingInfo = new HenganLoadingPlanPackingInfo();
  private isLoadingByCreate = false;
  private doAddHenganLoadingPlanLoading = false;
  public logisticsName = '';
  public sumbitBindShippingOrderDialogloading = false;
  private listQuery = {
    pageNumber: 1,
    pageSize: 20,
    customerAbbreviationOrCode: null,
    code: null,
    states: null,
    startDate: null,
    endDate: null,
    dateRange: null,
    bookingOrderCode: null
  };
  private total = 0;
  private shownCancelPopoverRowId: string = null;

  private showStockNot = false;

  created() {
    this.getList();
  }

  private canChange(row: any) {
    return !((row.hqPackingListState.name === 'IN_STORAGE' || row.hqPackingListState.name === 'PART_OF_OUTBOUND') && (!row.inventory || row.inventory === 'NO'));
  }

  private exportExcel() {
    const data = this.henganLoadingPlans.map((value) => {
      return {
        isTransshipDelivery: value.transshipDelivery ? "是" : "否",
        isLoadingInOneOrMorePlaces: value.loadingInOneOrMorePlaces
          ? "是"
          : "否",
        stateDesc: value.state.desc,
        ...value,
      };
    });
    const headers = [
      "出库计划单号",
      "客户简称",
      "创建日期",
      "是否驳货",
      "是否多地装柜",
      "状态",
      "订舱号",
      "海运提单号",
      "柜型及数量",
      "备注",
    ];
    const fieldNames = [
      "code",
      "customerAbbr",
      "createdAt",
      "isTransshipDelivery",
      "isLoadingInOneOrMorePlaces",
      "stateDesc",
      "shippingOrderCode",
      "",
      "",
      "remark",
    ];
    exportJson2Excel(
      headers,
      formatJson(fieldNames, data),
      `出库计划（销售）-${new Date()}`
    );
  }

  private handleCreateHenganLoadingPlan() {
    this.selectedHqPackingListIds = [];
    this.customsPackingTableData = [];
    this.customsPackingSet = [];
    this.createHenganLoadingPlanRequest = this.getCreateHenganLoadingPlanRequest();
    this.data = [];
    this.packingInfoRequest = new HenganLoadingPlanPackingInfo();
    this.getShippingOrders();
    this.getLogisticsSpecialist();
    this.createHenganLoadingPlanDialogVisible = true;
  }

  private getRowStyle({row}) {
    return row.loadingFirst ? 'success-row':'';
  }

  private gotoDocumentFlow(data) {
    this.$router.push({name: "DocumentFlow", params: {type: "HENG_AN_LOADING_PLAN", documentId: data.id}});
  }

  private async handleUpdateHenganLoadingPlan(rowData) {
    this.updateHenganLoadingPlanDialogVisible = true;
    const data_: any = await getHenganLoadingPlanProductAssigned(rowData.id);
    this.packingInfoRequest = data_;
    this.data = this.packingInfoRequest.packingInfos;
    this.filterTable = this.data;
    this.createHenganLoadingPlanRequest.customerId = this.packingInfoRequest.customerId;
    this.createHenganLoadingPlanRequest.logisticsSpecialistId = this.packingInfoRequest.logisticsSpecialistId;
    this.createHenganLoadingPlanRequest.companyCode = rowData.companyCode;
    this.createHenganLoadingPlanRequest.transshipDeclaration = rowData.transshipDeclaration !== null ? !rowData.transshipDeclaration : rowData.transshipDeclaration;
  }

  private addRemarkDialogVisible = false;

  private showAddRemarkDialog(row: HenganLoadingPlanTableRowData) {
    this.currentRow = cloneDeep(row);
    this.addRemarkDialogVisible = true;
  }

  private async doAddRemark() {
    await addRemark(this.currentRow.id, { remark: this.currentRow.remark });
    this.addRemarkDialogVisible = false;
    await this.getList();
  }

  private searchCustomers(a) {
    this.isLoadingCustomers = true;
    searchCustomer({ keyword: a })
      .then((res: any) => {
        this.customers = res;
        this.isLoadingCustomers = false;
      })
      .catch(() => {
        this.isLoadingCustomers = false;
      });
  }

  private async searchHqPackingList() {
    if (!this.createHenganLoadingPlanRequest.customerId) {
      Message.error({
        message: "请选择客户",
        duration: 2000,
      });
      return;
    }
    if (!this.createHenganLoadingPlanRequest.companyCode) {
      Message.error({
        message: "请选择公司",
        duration: 2000,
      });
      return;
    }
    // 1. 设置 loading 状态的 options
    this.cascaderOptions = [
      {
        id: "loading",
        code: "加载中...",
        disabled: true,
        bePackaged:false,
        factoryAbbreviation: "",
        children:[]
      },
    ];
    this.cascaderLoading = true;
    await searchCustomerHqPackingList(
      this.createHenganLoadingPlanRequest.customerId,
      { companyCode: this.createHenganLoadingPlanRequest.companyCode }
    ).then((res: any) => {
      this.cascaderOptions = res;
    }).finally(() => {
      this.cascaderLoading = false;
    });
  }

  private searchCustomsPackingLoading = false;
  private async searchCustomsPacking() {
    this.searchCustomsPackingLoading = true;
    await getHqPackingListsPackages({
      ids: this.selectedHqPackingListIds.join(","),
    }).then((res: any) => {
      let hqPackingLists: HqPackingListModel[] = res.map(
        (value) => value.hqPackingList
      );
      this.customsPackingSet = hqPackingLists
        .map((value) => value.customsPackingSet)
        .reduce((pre, cur) => pre.concat(cur), []);
      let customsPackingTableData = hqPackingLists
        .map((hqPackingList) =>
          hqPackingList.customsPackingSet.map(
            (value) =>
              new CustomsPackingTableRowData(
                hqPackingList.deliveryNoteId,
                hqPackingList.id,
                hqPackingList.deliveryNoteCode,
                hqPackingList.code,
                hqPackingList.state,
                hqPackingList.factoryName,
                value
              )
          )
        )
        .reduce((pre, cur) => pre.concat(cur), []);
      console.log(customsPackingTableData);
      this.getNewList(customsPackingTableData);
    }).catch((error)=> {
      this.$message.error(error.message);
    }).finally(() => {
      this.searchCustomsPackingLoading = false;
    });
  }

  private checkedAllSelect() {
    if (!this.checkedAll) {
      this.$nextTick(() => {
        this.customsPackingTableData.forEach((row) => {
          this.$set(row, "selected", false);
          this.onCustomsRowSelect(row);
        });
      });
      return
    }
    this.toggleSelection(this.customsPackingTableData);
  }

  private toggleSelection(rows: CustomsPackingTableRowData[]) {
    if (rows) {
      this.$nextTick(() => {
        rows.forEach((row) => {
          if(row.inventory !== 'MIX'
              && row.inventory !== 'YES'
              && row.purchaseOrderExceptionsProcessed === true
              && !row.exception) { // 全选不选择带库存的和采购订单存在超欠发情况的。
            this.$set(row, "selected", true);
          }
          this.onCustomsRowSelect(row);
        });
      });
    }
  }

  private cascaderLoading = false; // 控制级连选择器Loading
  private visibleChange(item) {
    // if(item && this.cascaderOptions.length === 0) {
    //   let options = {
    //     target: '.loadingCascader',//你自定义的类名
    //     lock: true,
    //     text: '拼命加载中...',
    //     background: 'rgba(0, 0, 0, 0.4)',
    //   };
    //   this.$nextTick(() => {
    //     this.cascaderLoading = this.$loading(options)
    //   });
    // }
  }

  private toggleChildrenCheckboxInCustomsPacking(
    rows: CustomsPackingTableRowData[],
    select: boolean
  ) {
    rows.map((row) => {
      row.secondaryRows.map((secondRow) => {
        secondRow.selected = select;
        this.toggleChildrenCheckboxInSecondaryPacking(
          secondRow.productRows,
          select
        );
      });
    });
  }

  private seleteAllUnpacking() {
    const filterTable = this.$refs.filterTable as any;
    filterTable.tableData.forEach(d => {
        d.unboxing = !d.unboxing;
    });
  }

  private seleteAllLoadingFirst() {
    const filterTable = this.$refs.filterTable as any;
    filterTable.tableData.forEach(d => {
      d.loadingFirst = !d.loadingFirst;
    });
  }

  private createSeleteAllUnpacking() {
    const filterTable = this.$refs.createFilterTable as any;
    filterTable.tableData.forEach(d => {
        d.unboxing = !d.unboxing;
    });
  }

  private createSeleteAllLoadingFirst() {
    const filterTable = this.$refs.createFilterTable as any;
    filterTable.tableData.forEach(d => {
      d.loadingFirst = !d.loadingFirst;
    });
  }

  private removeLoadingForUpdate = false;
  private removeLoadingForCreate = false;

  private async resetPackingInfos() {
    this.removeLoadingForCreate = true;
    const table = this.$refs.createFilterTable as any;
    const selected = (table?.selection || []).filter(
      (item) => item.packingType === "C"
    );
    if (selected.length === 0) {
      Message.error({
        message: "请先勾选要删除的主包装",
        duration: 2000,
      });
      this.removeLoadingForCreate = false;
      return;
    }
    const ids = selected.map((item) => item.packingId);
    this.data = this.data.filter((item) => !ids.includes(item.packingId));
    this.createHenganLoadingPlanRequest.packingInfos = this.data;
    this.updateFilterTable();
    await this.searchCustomsPacking();
    this.removeLoadingForCreate = false;
  }

  private async removePackingInfos() {
    this.removeLoadingForUpdate = true;
    const table = this.$refs.filterTable as any;
    const selected = (table?.selection || []).filter(
      (item) => item.packingType === "C"
    );
    if (selected.length === 0) {
      Message.error({
        message: "请先勾选要删除的主包装",
        duration: 2000,
      });
      this.removeLoadingForUpdate = false;
      return;
    }
    const packingIds = selected.map((item) => item.packingId);
    await removeHenganLoadingPlanPackingInfos(
      this.packingInfoRequest.henganLoadingPlanId,
      packingIds
    );
    const data_: any = await getHenganLoadingPlanProductAssigned(
      this.packingInfoRequest.henganLoadingPlanId
    );
    this.packingInfoRequest = data_;
    this.data = this.packingInfoRequest.packingInfos;
    this.updateFilterTable();

    this.removeLoadingForUpdate = false;
    this.$notify({
      title: "Success",
      message: "移除成功，请重新分配！",
      type: "success",
      duration: 2000,
    });
  }

  private downloadPreviewDetailLoading = false;
  private async downloadPreviewDetail() {
    if (this.data.length === 0) {
      Message.error({
        message: "请先选择一些包装后，再进行预览操作",
        duration: 2000,
      });
      return;
    }
    const ids = this.data.map(item => item.packingId);
    this.downloadPreviewDetailLoading = true;
    try {
      await downloadPreviewDetail(ids);
    }catch (err){
      console.error( err)
    }finally {
      this.downloadPreviewDetailLoading = false;
    }
  }

  private handleRefresh(type: string) {
    let refTable;
    if (type === "create") {
      refTable = this.$refs.createFilterTable as any;
    }
    if (type === "update") {
      refTable = this.$refs.filterTable as any;
    }
    refTable.clearFilter();
    this.factoryNameFilters = [];
    this.deliveryNoteCodeFilters = [];
    this.filterTable = this.data;
  }

  private getSelectNum() {
    // if (this.filterTable.length === 0) {
    //   return this.data.length + "/" + this.data.length;
    // }else {
    //   return this.filterTable.length + "/" + this.data.length.toString();
    // }
    return this.filterTable.length + "/" + this.data.length;
  }

  private getSummaries(params) {
    const {columns, data} = params;
    const sums = [];
    columns.forEach((column, index) => {
      if (index === 0) {
        sums[index] = "";
      }
      if (index === 1) {
        sums[index] = "合计:\n" + data.reduce((pre) => {
            return pre + 1;
        }, 0);
      }
      if (index === 2) {
        sums[index] = "CTN:\n" + data.reduce((pre, cur) => {
          if (!cur.packingCode.includes("次包装") &&
              !cur.packingCode.includes("产品") &&
              cur.packingCode.includes("CTN")){
            return pre + 1;
          }else {
            return pre;
          }
        }, 0);
      }
      if (index === 3) {
        sums[index] = "PLT:\n" + data.reduce((pre, cur) => {
          if (!cur.packingCode.includes("次包装") &&
              !cur.packingCode.includes("产品") &&
              cur.packingCode.includes("PLT")){
            return pre + 1;
          }else {
            return pre;
          }
        }, 0);
      }
      if (index === 4) {
        sums[index] = "次包装:\n" + data.reduce((pre, cur) => {
          if (cur.packingCode.includes("次包装")){
            return pre + 1;
          }else {
            return pre;
          }
        }, 0);
      }
      if (index === 5) {
        sums[index] = "产品:\n" + data.reduce((pre, cur) => {
          if (cur.packingCode.includes("产品")){
            return pre + 1;
          }else {
            return pre;
          }
        }, 0);
      }
      if (index === 6) {
        sums[index] = "体积:\n" + data.reduce((pre, cur) => {
          return pre + Number(cur.volume);
        }, 0).toFixed(2);
      }
      if (index === 7) {
        sums[index] = "数量:\n" + data.reduce((pre, cur) => {
          return pre + Number(cur.totalProductQuantity);
        }, 0);
      }
      if (index === 8) {
        let totalPrice = data.reduce((pre, cur) => {
          return pre + Number(cur.totalPrice);
        }, 0);
        const priceText = formatPrice(totalPrice);
        if (hasMoreThanTwoDecimals(Number(priceText))) {
          const h = this.$createElement;
          sums[index] = h("div", { class: "summary-price-wrap" }, [
            h(
              "el-tooltip",
              {
                props: {
                  content: "合计价格的小数位数不能超过两位",
                  placement: "top",
                  effect: "dark",
                },
              },
              [
                h("i", {
                  class: "el-icon-warning summary-price-warn",
                }),
              ]
            ),
            "价格:\n" + priceText,
          ]);
        } else {
          sums[index] = "价格:\n" + priceText;
        }
      }
      if (index === 9) {

      }
    });
    return sums;
  }

  private isMainPackingSelectable(row: PackingInfo) {
    return row.packingType === "C";
  }

  private toggleChildrenCheckboxInSecondaryPacking(
    rows: ProductTableRowData[],
    select: boolean
  ) {
    rows.map((row) => {
      row.selected = select;
    });
  }

  private toggleParentCheckboxByProductRow(productRow: ProductTableRowData) {
    for (let i = 0; i < this.customsPackingTableData.length; i++) {
      for (
        let j = 0;
        j < this.customsPackingTableData[i].secondaryRows.length;
        j++
      ) {
        if (
          this.customsPackingTableData[i].secondaryRows[j].id === productRow.pid
        ) {
          let secondaryPackingRows: SecondaryPackingTableRowData[] =
            this.customsPackingTableData[i].secondaryRows;
          secondaryPackingRows.map((value) => value.updateSelectState());
          this.customsPackingTableData[i].updateSelectState();
          return;
        }
      }
    }
  }

  private toggleParentCheckboxBySecondaryPackingRow(
    row: SecondaryPackingTableRowData
  ) {
    const parent: CustomsPackingTableRowData =
      this.customsPackingTableData.filter((value) => value.id === row.pid)[0];
    parent.updateSelectState();
  }

  private onCustomsRowSelect(row: CustomsPackingTableRowData) {
    row.indeterminate = false;
    this.toggleChildrenCheckboxInCustomsPacking([row], row.selected);
  }

  private onSecondaryRowSelect(row: SecondaryPackingTableRowData) {
    row.indeterminate = false;
    this.toggleChildrenCheckboxInSecondaryPacking(
      row.productRows,
      row.selected
    );
    this.toggleParentCheckboxBySecondaryPackingRow(row);
  }

  private onProductRowSelect(row: ProductTableRowData) {
    this.toggleParentCheckboxByProductRow(row);
  }

  private onSelectedProductQuantityChange(row: ProductTableRowData) {
    row.selected = true;
    this.toggleParentCheckboxByProductRow(row);
  }

  private getFactoryNameFilters(){
    let factoryNames: string[] = Array.from(new Set(this.data.map(value => value.factoryName)));
    let filterData = [];
    factoryNames.map(value => {
      filterData.push({text: value,value: value});
    });
    return filterData;
  }

  private getDeliveryNoteFilters() {
    let deliveryNoteCodes: string[] = Array.from(new Set(this.data.map(value => value.deliveryNoteCode)));
    let filterData = [];
    deliveryNoteCodes.map(value => {
      filterData.push({text: value,value: value});
    });
    return filterData;
  }

  private filterTable = [];
  private factoryNameFilters = [];
  private deliveryNoteCodeFilters = [];
  private filterHandler(value, row) {
    return row.factoryName === value;
  }

  private filterChange(filters) {
    if (filters.factoryName !== undefined) {
      this.factoryNameFilters = filters.factoryName;
    }
    if (filters.deliveryNoteCode !== undefined) {
      this.deliveryNoteCodeFilters = filters.deliveryNoteCode;
    }
    this.updateFilterTable();
  }

  private updateFilterTable() {
    if (this.factoryNameFilters.length === 0 && this.deliveryNoteCodeFilters.length === 0) {
      this.filterTable = this.data;
    }else {
      let filter = this.data;
      if (this.factoryNameFilters.length > 0) {
        filter = filter.filter(item => this.factoryNameFilters.includes(item.factoryName));
      }
      if (this.deliveryNoteCodeFilters.length > 0) {
        filter = filter.filter(item => this.deliveryNoteCodeFilters.includes(item.deliveryNoteCode));
      }
      this.filterTable = filter;
    }
  }

  private filterDeliveryNoteHandler(value, row) {
    return row.deliveryNoteCode === value;
  }

  private deleteCatalogProduct(packingId: string, type: string) {
    this.data = this.data.filter(d => d.packingId !== packingId);
    this.createHenganLoadingPlanRequest.packingInfos = this.data;
    if (type === 'update') {
      removeHenganLoadingPlanPackingInfos(this.packingInfoRequest.henganLoadingPlanId, [packingId]);
    }
    this.updateFilterTable();
    this.searchCustomsPacking();
  }

  private gotoEditPage(id: string) {
    let routeData = this.$router.resolve({
      name: "HqPackingListDetailForEdit",
      params: {hqPackingListId: id, type: "hengan_loading_plan", parentId: "aaa"},
    });
    window.open(routeData.href, "_blank");
  }

  public async doAddHenganLoadingPlanth(type: string) {
    this.doAddHenganLoadingPlanLoading = true;
    await this.doAddHenganLoadingPlan(type);
  }

  public async doAddHenganLoadingPlan(type: string) {
    const packingInfos: PackingInfo[] = [];
    for (let i = 0; i < this.customsPackingTableData.length; i++) {
      const customsRow = this.customsPackingTableData[i];
      if (customsRow.selected) {
        packingInfos.push(
          new PackingInfo(customsRow.id, "C", 0,
            customsRow.loadingFirst,
            customsRow.displayCode,
            customsRow.declarationDescriptions,
            customsRow.volume,
            customsRow.purchaseOrderNumbers,
            customsRow.factoryName,
            customsRow.totalProductQuantity,
            customsRow.totalPrice,
            customsRow.hqPackingListCode,
            customsRow.deliveryNoteCode,
            customsRow.hqPackingListId,
            customsRow.deliveryNoteId,
            false
          )
        );
      } else {
        for (let j = 0; j < customsRow.secondaryRows?.length; j++) {
          const secondaryRow: SecondaryPackingTableRowData =
            customsRow.secondaryRows[j];
          if (secondaryRow.selected) {
            packingInfos.push(
              new PackingInfo(
                secondaryRow.id,
                "S",
                0,
                secondaryRow.loadingFirst,
                "次包装\n" + customsRow.displayCode,
                secondaryRow.declarationDescriptions,
                secondaryRow.volume,
                secondaryRow.purchaseOrderNumbers,
                secondaryRow.factoryName,
                secondaryRow.totalProductQuantity,
                secondaryRow.totalPrice,
                customsRow.hqPackingListCode,
                customsRow.deliveryNoteCode,
                customsRow.hqPackingListId,
                customsRow.deliveryNoteId,
                false
              )
            );
          } else {
            for (let k = 0;k < secondaryRow.productRows.length; k++) {
              const productRow = secondaryRow.productRows[k];
              if (productRow.selected) {
                packingInfos.push(new PackingInfo(
                  productRow.id,
                  "P",
                  productRow.quantity,
                  productRow.loadingFirst,
                  "产品\n" + customsRow.displayCode,
                  productRow.declarationDescription,
                  "0.00",
                  productRow.purchaseOrderNumber,
                  customsRow.factoryName,
                  productRow.quantity,
                  productRow.unitPrice.toFixed(2),
                  customsRow.hqPackingListCode,
                  customsRow.deliveryNoteCode,
                  customsRow.hqPackingListId,
                  customsRow.deliveryNoteId,
                  false
                ));
              }
            }
          }
        }
      }
    }
    try {
      await checkPacking(packingInfos.filter(item => item?.packingId != null).map(item => item.packingId));
      this.data.push(...packingInfos);
      this.createHenganLoadingPlanRequest.packingInfos = this.data;
      if (type === "update") {
        await updateHenganLoadingPlanPackingInfos(this.packingInfoRequest.henganLoadingPlanId, packingInfos);
      }
      this.updateFilterTable();
      await this.searchCustomsPacking();
    }catch (error) {
      console.error(error);
    } finally {
      this.doAddHenganLoadingPlanLoading = false;
    }
  }

  private closeCreateHenganLoadingPlan() {
    this.createHenganLoadingPlanDialogVisible = false;
    this.clearCache();
  }

  private closeUpdateHenganLoadingPlan() {
    this.updateHenganLoadingPlanDialogVisible = false;
    this.clearCache();
  }

  private clearCache() {
    this.customers = [];
    this.logisticsName = "";
    this.cascaderOptions = [];
    this.filterTable = [];
    this.factoryNameFilters = [];
    this.deliveryNoteCodeFilters = [];
    this.customsPackingTableData = [];
    this.assignedProductsPopoverVisible = false;
    const createRefTable = this.$refs.createFilterTable as any;
    if (createRefTable) {
      createRefTable.clearFilter();
    }
    const refTable = this.$refs.filterTable as any;
    if(refTable) {
      refTable.clearFilter();
    }
  }

  public async doCreateOrUpdateHenganLoadingPlan() {
    // 0为新建
    this.isLoadingByCreate = true;
    // 选项不勾选默认报关，勾选了则不报关。
     const data:CreateHenganLoadingPlanRequest =  {...this.createHenganLoadingPlanRequest,
     transshipDeclaration: !this.createHenganLoadingPlanRequest.transshipDeclaration};
     try {
       await createOrUpdateHenganLoadingPlan(data, "0");
       this.createHenganLoadingPlanDialogVisible = false;
       this.isLoadingByCreate = false;
       this.clearCache();
       this.$notify({
         title: "Success",
         message: "创建成功",
         type: "success",
         duration: 2000
       });
       this.data = [];
      await this.getList();
     }catch (err) {
       console.error(err);
     }finally {
       this.isLoadingByCreate = false;
     }
  }

  public doUpdateHenganLoadingPlan() {
    this.createHenganLoadingPlanRequest.packingInfos = this.data;
    createOrUpdateHenganLoadingPlan(this.createHenganLoadingPlanRequest, this.packingInfoRequest.henganLoadingPlanId)
        .then((data: any) => {
          if (data.message !== "") {
            Message.error({ message: data.message, duration: 2000 });
          }
          this.updateHenganLoadingPlanDialogVisible = false;
          this.data = [];
          this.clearCache();
          this.$notify({
            title: "Success",
            message: "更新成功",
            type: "success",
            duration: 2000
          });
          this.getList();
        });
  }


  private getNewList(customsPackingTableData: CustomsPackingTableRowData[]) {
    let customsPackingIds = this.data.filter(v => v.packingType==="C").map(c => c.packingId);
    let secondaryIds = this.data.filter(v => v.packingType==="S").map(c => c.packingId);
    let productIds = this.data.filter(v => v.packingType==="P").map(c => c.packingId);
    // 排除已分配的主包装
    this.customsPackingTableData = customsPackingTableData.filter(c => !(customsPackingIds.indexOf(c.id) > -1));
    for (let i = 0; i < this.customsPackingTableData.length; i++) {
      let secondaryPackingTableRowData = this.customsPackingTableData[i].secondaryRows.filter(s => !(secondaryIds.indexOf(s.id) > -1));
      // 排除已分配的次包装
      for (let j = 0; j < secondaryPackingTableRowData.length; j++) {
        let product = secondaryPackingTableRowData[j].productRows;
        // 排除已分配的产品
        secondaryPackingTableRowData[j].productRows = product.filter(p => !(productIds.indexOf(p.id) > -1));
      }
      this.customsPackingTableData[i].secondaryRows = secondaryPackingTableRowData;
    }
    if(!this.showStockNot) { //展示库存--表格上方是否展示库存
      this.customsPackingTableData = this.customsPackingTableData.filter(c => (c.inventory !== 'YES' && c.inventory !== 'MIX'))
    }
    console.log(this.customsPackingTableData);
  }

  private async getList() {
    if (this.listQuery.dateRange) {
      this.listQuery.startDate = this.listQuery.dateRange[0];
      this.listQuery.endDate = this.listQuery.dateRange[1];
    }
    const params = { ...this.listQuery };
    params.dateRange = null;
    await getHenganLoadingPlans(params)
      .then((res: any) => {
        this.total = res.total;
        this.henganLoadingPlans = res.content;
        this.henganLoadingPlans.map((item,index) => {item.sn = index + 1})
      })
      .catch((error) => {
        Message.error({
          message: error.message,
          duration: 2000,
        });
      });
  }

  private async getLogisticsSpecialist() {
    if (!this.logisticsSpecialist || this.logisticsSpecialist.length < 1) {
      const data: any = await getUsersByJobPosition("logistics-clerk");
      this.logisticsSpecialist = data;
    }
  }

  private getShippingOrders() {
    getShippingOrders().then((res: any) => {
      this.shippingOrders = res;
    });
  }

  private checkImages(row: HenganLoadingPlanTableRowData) {
    this.$router.push({
      name: "ImageManagement",
      params: { bizType: "hengan-loading-plan", objectId: row.id },
    });
  }

  private checkDetail(row: HenganLoadingPlanTableRowData) {
    this.$router.push({
      name: "HenganLoadingPlanDetail",
      params: { id: row.id },
    });
  }

  private async onAddShippingOrderClick(row: HenganLoadingPlanTableRowData) {
    this.currentRow = row;
    this.addShippingOrderDialogVisible = true;
    await getShippingOrders(this.currentRow.customerId, this.currentRow.companyCode).then((res: any) => {
      this.shippingOrders = res;
    });
  }

  private async onAddShippingOrderConfirmClick() {
    this.sumbitBindShippingOrderDialogloading = true;
    try {
      await addShippingOrder(this.currentRow.id, {
        shippingOrderId: this.currentSelectedShippingOrderId,
      });
      this.currentSelectedShippingOrderId = null;
      this.shippingOrders = [];
      await this.getList();
      this.addShippingOrderDialogVisible = false;
    }catch (e){
      console.error(e);
    }finally {
      this.sumbitBindShippingOrderDialogloading = false;
    }
  }

  private handleReleaseContainerType(row: HenganLoadingPlanTableRowData) {
    this.currentRow = row;
    this.releaseContainerTypeDialogVisible = true;
    this.isLoadingContainerTypeReleasedInfo = true;
    this.getContainerTypeReleasedInfo(row.shippingOrderId);
  }

  private getContainerTypeReleasedInfo(shippingOrderId) {
    getShippingOrderContainerTypeReleasedInfo(shippingOrderId, {
      loadingPlanId: this.currentRow.id,
      type: "HENGAN_LOADING_PLAN",
    })
      .then((res: any) => {
        this.containerTypeReleasedInfo = res;
        this.isLoadingContainerTypeReleasedInfo = false;
      })
      .catch(() => (this.isLoadingContainerTypeReleasedInfo = false));
  }

  private async doReleaseContainerType(
    data: [{ id: string; loadingInOneOrMorePlaces: string }]
  ) {
    if (data.length < 1) {
      Message.error({
        message: "请选择柜型",
        duration: 2000,
      });
      return;
    }
    await releaseContainerType(this.currentRow.id, { containerTypes: data });
    this.getContainerTypeReleasedInfo(this.currentRow.shippingOrderId);
  }

  private async doRemoveContainerType(containerTypeId: string) {
    let data = {"loadingPlanId":this.currentRow.id,"loadingPlanType":"HENGAN_LOADING_PLAN"};
    await deleteContainerTypeRelations(containerTypeId, data);
    this.getContainerTypeReleasedInfo(this.currentRow.shippingOrderId);
  }

  private async doChangeLoadingType(
    containerTypeId: string,
    loadingInOneOrMorePlaces: boolean
  ) {
    await updateContainerTypeLoadingType(containerTypeId, {
      loadingInOneOrMorePlaces,
    });
    this.getContainerTypeReleasedInfo(this.currentRow.shippingOrderId);
  }

  // 配置柜型
  private configContainerTypeDialogVisible = false;
  private configContainerTypeDialogEditable = true;
  private containerTypeConfigurationInfo: ContainerTypeConfigurationInfo =
    new ContainerTypeConfigurationInfo();

  private showConfigContainerTypeDialog(
    row: HenganLoadingPlanTableRowData,
    configurationEditable = true,
    title: string
  ) {
    this.configContainerTypeDialogVisibleTitle = title
    this.currentRow = row;
    this.configContainerTypeDialogVisible = true;
    this.configContainerTypeDialogEditable = configurationEditable;
    this.getContainerTypeConfigurationInfo();
  }

  private getContainerTypeConfigurationInfo() {
    getContainerTypeConfigurationInfoForWarehouse(this.currentRow.id).then(
      (res: any) => {
        this.containerTypeConfigurationInfo = res;
      }
    );
  }

  private async onSaveLoadingInfos(
    createDeliveryList: boolean,
    loadingInfos: LoadingInfo[]
  ) {
    const request: ConfigContainerTypeRequest =
      new ConfigContainerTypeRequest();
    request.henganLoadingPlanId = this.currentRow.id;
    request.createDeliveryList = createDeliveryList;
    request.loadingInfos = loadingInfos.map((value) => {
      const r: CreateLoadingInfoRequest = new CreateLoadingInfoRequest();
      Object.assign(r, value);
      r.henganCustomsPackingIds = value.customsPackingSet.map(
        (value) => value.id
      );
      r.containerTypeId = value.containerType?.id || value.containerTypeId;
      return r;
    });
    await saveLoadingInfosFowSeller(request);
    this.configContainerTypeDialogVisible = false;
    await this.getList();
  }

  private async onDeleteLoadingInfo(loadingInfoId: string) {
    await deleteLoadingInfosForSeller(loadingInfoId);
    this.getContainerTypeConfigurationInfo();
  }

  /**
   * 取消出库计划
   * @param henganLoadingPlanId
   * @private
   */
  private async cancelHenganLoadingPlan(henganLoadingPlanId: string) {
    await cancelHenganLoadingPlan(henganLoadingPlanId);
    this.shownCancelPopoverRowId = null;
    await this.getList();
  }
  private containerTypeIsLCL(containerTypeInfos: string[]): boolean{
    const LclIsExisted = containerTypeInfos.filter((value => value === "LCL*1"))[0];
    return !LclIsExisted;
  }
  private bindLogistics() {
    if (this.createHenganLoadingPlanRequest.customerId) {
      this.customers.filter(value => {
        if (value.id === this.createHenganLoadingPlanRequest.customerId){
          this.logisticsName = value.logisticsSpecialistName;
          this.createHenganLoadingPlanRequest.logisticsSpecialistId = value.logisticsSpecialistId;
        }
      })
    }
   this.initData();
  }

  /**
   * 初始化数据。对于创建出库计划时，无论是更换了公司还是客人，都应该初始化数据；
   * @private
   */
  private initData() {
    this.customsPackingTableData =[];
    this.selectedHqPackingListIds = [];
    this.data = [];
  }

  private renderCusAbbr(prop, row) {
    if (row.pcNames && row.pcNames.length > 0){
      return `[${row.pcNames}]${prop}`
    }
    return prop
  }
  private getCreateHenganLoadingPlanRequest():CreateHenganLoadingPlanRequest {
   let req =   new CreateHenganLoadingPlanRequest();
   req.transshipDelivery = false;
   req.transshipDeclaration = false;
    return req;
  }

  private async fetchNodeDetails(node: any, data: any) {
    if (!node.isLeaf) return ""; // 不是叶子节点，不发请求，直接返回空

    try {
      const res: any = await queryOriginalPackingListInfoByCLPackingList(data.id);
      if (res && res.length > 0) {
        return res;
      }
      return ""; // 没有数据，返回空字符串
    } catch (e) {
      console.error(e);
      return ""; // 出错时也不显示
    }
  }

  /**
   * 打开更新舱单对话框
   * @private
   */
  private updateShippingOrderDialogVisible = false;
  private curSelectedShippingOrderId = "";
  private loadingRowId = "";
  private async openUpdateShippingOrderDialog(row: HenganLoadingPlanTableRowData) {
    this.loadingRowId = row.id;
    this.currentRow = row;
    await getShippingOrders(this.currentRow.customerId, this.currentRow.companyCode).then((res: any) => {
      this.shippingOrders = res;
    });
    this.updateShippingOrderDialogVisible = true;
    this.curSelectedShippingOrderId = row.shippingOrderId;
    await this.$nextTick();
  }

  /**
   * 清空并关闭更新舱单对话框
   * @private
   */
  private clearUpdateShippingOrderDialog() {
    this.updateShippingOrderDialogVisible = false;
    this.curSelectedShippingOrderId = "";
    this.shippingOrders = [];
    this.loadingRowId = "";
  }

  /**
   * 更新舱单
   * @private
   */
  private updateShippingOrderLoading = false;
  private async updateShippingOrder() {
    this.updateShippingOrderLoading = true;
    try {
      await updateShippingOrder(this.currentRow.id, this.curSelectedShippingOrderId);
      this.clearUpdateShippingOrderDialog();
    } catch (e) {
      console.error(e);
    } finally {
      this.updateShippingOrderLoading = false;
    }
  }

  private assignedProductsPopoverVisible = false;
  private previewVisible = false;
  private previewLoading = false;
  private previewItems: CustomsDeclarationPreviewItem[] = [];

  private packingListProductVisible = false;
  private packingListProductLoading = false;
  private packingListProductItems: PackingListProductItem[] = [];

  private piProductVisible = false;
  private piProductLoading = false;
  private piProductItems: PiProductItem[] = [];

  private async declarationPreview() {
    const customsPackingIds = this.data.map(item => item.packingId);
    const data = {
      customerId: this.createHenganLoadingPlanRequest.customerId,
      customsPackingIds: customsPackingIds,
    }

    this.previewItems = [];
    this.previewVisible = true;
    this.previewLoading = true;
    try {
      this.previewItems = await previewCustomsDeclaration(data) as any;
    } finally {
      this.previewLoading = false;
    }
  }

  private async showPackingListProductList() {
    this.packingListProductItems = [];
    this.packingListProductVisible = true;
    this.packingListProductLoading = true;
    try {
      const cIds = this.data.map(item => item.packingId);
      this.packingListProductItems = await detailQueryQtyStepInfoByPackingList({ packingIds: cIds }) as any;
    } finally {
      this.packingListProductLoading = false;
    }
  }

  private async showPiProductList() {
    this.piProductItems = [];
    this.piProductVisible = true;
    this.piProductLoading = true;
    try {
      const cIds = this.data.map(item => item.packingId);
      this.piProductItems = await detailQueryQtyStepInfoByPi({ packingIds: cIds }) as any;
    } finally {
      this.piProductLoading = false;
    }
  }
}

class CreateHenganLoadingPlanRequest {
  customerId: string;
  companyCode: string;
  shippingOrderId: string;
  transshipDelivery: boolean;
  transshipDeclaration: boolean;
  logisticsSpecialistId: string;
  remark: string;
  referencePackingData: boolean;
  packingInfos: PackingInfo[];
}


class HenganLoadingPlanPackingInfo {
  henganLoadingPlanId: string;
  henganLoadingPlanCode: string;
  logisticsSpecialistId: string;
  logisticsSpecialistName: string;
  customerId: string;
  customerAbbreviation: string;
  transshipDelivery: boolean;
  transshipDeclaration: boolean;
  remark: string;
  packingInfos: PackingInfo[];
}

class PackingInfo {
  id: string;
  henganLoadingPlanId: string;
  packingId: string;
  packingType: string;
  quantity: number;
  loadingFirst: boolean;
  packingCode: string;
  declarationDescriptions: string;
  volume: number;
  purchaseOrderNumbers: string;
  factoryName: string;
  totalProductQuantity: number;
  totalPrice: string;
  hqPackingListCode: string;
  deliveryNoteCode: string;
  deliveryNoteId: string;
  hqPackingListId: string;
  unboxing: boolean;

  constructor(
    packingId: string,
    packingType: string,
    quantity: number,
    loadingFirst: boolean,
    packingCode: string,
    declarationDescriptions: string,
    volume: string,
    purchaseOrderNumbers: string,
    factoryName: string,
    totalProductQuantity: number,
    totalPrice: string,
    hqPackingListCode: string,
    deliveryNoteCode: string,
    hqPackingListId: string,
    deliveryNoteId: string,
    unboxing: boolean
  ) {
    this.packingId = packingId;
    this.packingType = packingType;
    this.quantity = quantity;
    this.loadingFirst = loadingFirst;
    this.packingCode = packingCode;
    this.declarationDescriptions = declarationDescriptions;
    this.volume = parseFloat(volume);
    this.purchaseOrderNumbers = purchaseOrderNumbers;
    this.factoryName = factoryName;
    this.totalProductQuantity = totalProductQuantity;
    this.totalPrice = totalPrice;
    this.hqPackingListCode = hqPackingListCode;
    this.deliveryNoteCode = deliveryNoteCode;
    this.hqPackingListId = hqPackingListId;
    this.deliveryNoteId = deliveryNoteId;
    this.unboxing = unboxing;
  }
}

class Customer {
  id: string;
  code: string;
  abbreviation: string;
  logisticsSpecialistId: string;
  logisticsSpecialistName: string;
}

class CascaderOptionItem {
  id: string;
  code: string;
  bePackaged: boolean;
  disabled: boolean;
  factoryAbbreviation: string;
  children: CascaderOptionItem[];
}

class CustomsPackingTableRowData {
  id: string;
  deliveryNoteId: string;
  hqPackingListId: string;
  deliveryNoteCode: string;
  hqPackingListCode: string;
  hqPackingListState: HqPackingListState;
  factoryName: string;
  displayCode: string;
  volume: string;
  grossWeight: string;
  netWeight: string;
  selected: boolean;
  loadingFirst: boolean;
  indeterminate: boolean;
  totalPrice: string;
  descriptions: string;
  declarationDescriptions: string;
  purchaseOrderNumbers: string;
  totalProductQuantity: number;
  inventory: string;
  useInventoryQuantity: number;
  purchaseOrderExceptionsProcessed: boolean;
  exception: boolean;
  exceptionReason: CustomsPackingProblemType;
  secondaryRows: SecondaryPackingTableRowData[] = [];

  constructor(
    deliveryNoteId: string,
    hqPackingListId: string,
    deliveryNoteCode: string,
    hqPackingListCode: string,
    hqPackingListState: HqPackingListState,
    factoryName: string,
    customsPacking: CustomsPackingModel
  ) {
    this.deliveryNoteId = deliveryNoteId;
    this.hqPackingListId = hqPackingListId;
    this.deliveryNoteCode = deliveryNoteCode;
    this.hqPackingListCode = hqPackingListCode;
    this.hqPackingListState = hqPackingListState;
    this.factoryName = factoryName;
    if (customsPacking) {
      this.id = customsPacking.id;
      this.volume = this.calculateVolume(customsPacking.packingVolume);
      this.grossWeight = String(customsPacking.packingWeight?.grossWeight);
      this.netWeight = String(customsPacking.packingWeight?.netWeight);
      this.inventory = customsPacking.inventory;
      this.purchaseOrderExceptionsProcessed = customsPacking.purchaseOrderExceptionsProcessed;
      this.exception = customsPacking.exception;
      this.exceptionReason = customsPacking.exceptionReason;
      this.useInventoryQuantity = customsPacking.useInventoryQuantity;
      this.displayCode =
        customsPacking.code.typeCode +
        customsPacking.code.selfCode +
        "#" +
        customsPacking.code.serialNumber;
      this.secondaryRows = customsPacking.secondaryPackingSet?.map(
        (value) =>
          new SecondaryPackingTableRowData(
            customsPacking.id,
            factoryName,
            value,
            hqPackingListState,
            this.inventory
          )
      );
      let totalPrice = this.secondaryRows
        ?.map((value) => value.totalPrice)
        .reduce((pre, cur) => pre + Number(cur), 0);
      this.totalPrice = formatPrice(totalPrice);
      this.descriptions = this.unique(this.secondaryRows
        ?.map((value) => value.descriptions))
        .join(",");
      this.declarationDescriptions = this.unique(this.secondaryRows
        ?.map((value) => value.declarationDescriptions))
        .join(",");
      this.purchaseOrderNumbers = this.unique(this.secondaryRows
        ?.map((value) => value.purchaseOrderNumbers))
        .join(",");
      this.totalProductQuantity = this.secondaryRows
        ?.map((value) => value.totalProductQuantity)
        .reduce((pre, cur) => pre + Number(cur), 0);
    }
    this.selected = false;
    this.loadingFirst = false;
    this.indeterminate = false;
  }

  unique(arr) {
    return Array.from(new Set(arr));
  }

  calculateVolume(packingVolume: PackingVolume): string {
    return new PackingVolume(
      packingVolume.length,
      packingVolume.width,
      packingVolume.height
    ).calculateVolume();
  }

  updateSelectState() {
    const childrenCount: number = this.secondaryRows.length;
    const childrenSelectedCount: number = this.secondaryRows.filter(
      (value) => value.selected
    ).length;
    const childrenIndeterminateCount: number = this.secondaryRows.filter(
      (value) => value.indeterminate
    ).length;
    this.selected = childrenSelectedCount === childrenCount;
    this.indeterminate =
      (!this.selected && childrenSelectedCount > 0) ||
      childrenIndeterminateCount > 0;
  }

  updateLoadingFirst(value: boolean) {
    this.loadingFirst = value;
  }
}

class SecondaryPackingTableRowData extends CustomsPackingTableRowData {
  // id: string;
  pid: string;
  cartonNumber: number;
  hqPackingListState: HqPackingListState;
  productRows: ProductTableRowData[] = [];
  inventory: string;

  constructor(
    pid: string,
    factoryName: string,
    secondaryPacking: SecondaryPackingModel,
    hqPackingListState: HqPackingListState,
    inventory: string
  ) {
    super(null, null,null, null, null ,factoryName, null);
    this.id = secondaryPacking.id;
    this.pid = pid;
    this.cartonNumber = secondaryPacking.cartonNumber;
    this.factoryName = factoryName;
    this.hqPackingListState = hqPackingListState;
    const packingWeights: PackingWeight[] = secondaryPacking.packingInfos
      .map((value) => value.packingWeight)
      .reduce((pre, cur) => pre.concat(cur), []);
    this.netWeight = packingWeights
      .map((value) => value.netWeight)
      .reduce((pre, cur) => pre + Number(cur), 0)
      .toFixed(2);
    this.grossWeight = packingWeights
      .map((value) => value.grossWeight)
      .reduce((pre, cur) => pre + Number(cur), 0)
      .toFixed(2);
    // this.netWeight = secondaryPacking.packingInfoRequest.map(value => value.netWeight).reduce((pre, cur) => pre + Number(cur), 0).toFixed(2);
    // this.grossWeight = secondaryPacking.packingInfoRequest.map(value => value.grossWeightPerCarton).reduce((pre, cur) => pre + Number(cur), 0).toFixed(2);
    this.volume = secondaryPacking.packingInfos
      .map((value) => this.calculateVolume(value.packingVolume))
      .reduce((pre, cur) => pre + Number(cur), 0)
      .toFixed(2);
    // const productInfos = secondaryPacking.productInfos;
    const productInfos = secondaryPacking.packingInfos
      .map((value) => value.productInfos)
      .reduce((pre, cur) => pre.concat(cur), []);
    this.totalPrice = productInfos
      .map((value) => value.unitPrice * value.totalNumberPcs)
      .reduce((pre, cur) => pre + Number(cur), 0)
      .toFixed(2);
    this.descriptions = super.unique(productInfos
      .map((value) => value.description))
      .join(",");
    this.declarationDescriptions = super.unique(productInfos
      .map((value) => value.declarationDescription))
      .join(",");
    this.purchaseOrderNumbers = super.unique(productInfos
      .map((value) => value.purchaseOrderNumber))
      .join(",");
    this.totalProductQuantity = productInfos
      .map((value) => value.totalNumberPcs)
      .reduce((pre, cur) => pre + Number(cur), 0);
    this.inventory = inventory;
    this.productRows = productInfos.map((value) => {
      return {
        pid: secondaryPacking.id,
        quantity: value.totalNumberPcs,
        selected: false,
        loadingFirst: false,
        hqPackingListState: hqPackingListState,
        ...value,
      };
    });
  }

  updateSelectState() {
    const childrenCount: number = this.productRows.length;
    const childrenSelectedCount: number = this.productRows.filter(
      (value) => value.selected
    ).length;
    this.selected = childrenSelectedCount === childrenCount;
    if (childrenSelectedCount === childrenCount) {
      const childrenSelectedProductQuantity: number = this.productRows
        .filter((value) => value.selected)
        .map((value) => value.quantity)
        .reduce((pre, cur) => pre + Number(cur), 0);
      this.selected =
        this.totalProductQuantity === childrenSelectedProductQuantity;
      this.indeterminate = true;
    } else {
      this.selected = false;
      this.indeterminate = false;
    }
    this.indeterminate = !this.selected && childrenSelectedCount > 0;
  }
}

class ProductTableRowData extends ProductInfo {
  pid: string;
  quantity = 0;
  selected = false;
  loadingFirst = false;
}

class HenganLoadingPlanTableRowData {
  id: string;
  code: string;
  customerAbbr: string;
  customerId: string;
  createdAt: Date;
  state: { name: string; desc: string };
  remark: string;
  transshipDelivery: boolean;
  transshipDeclaration: boolean;
  shippingOrderId: string;
  shippingOrderCode: string;
  loadingInOneOrMorePlaces: string;
  billOfLadingCode: string;
  deliveryListId: string;
  containerTypeInfos: string[];
  bookingOrderCodes: string;
  companyCode: string;
}
